import { render, staticRenderFns } from "./ViewGames.vue?vue&type=template&id=31fdbf4e&"
import script from "./ViewGames.vue?vue&type=script&lang=js&"
export * from "./ViewGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports